import { objectToQueryString } from 'site-modules/shared/utils/string';

/**
 * Builds the AI assistant canvas URL from the current location.
 * @param {Object} location - The location object with pathname and search.
 * @param {Object} [extraParams] - Additional query parameters to include.
 * @returns {string} The AI assistant URL.
 */
export function buildAiAssistantUrl(location, extraParams = {}) {
  return `/ai-assistant/?${objectToQueryString({ page: `${location.pathname}${location.search}`, ...extraParams })}`;
}
